import { everifyCaseQueueIdFromPartnerToken } from '@/features/pending_everify/application/validators/partner-everify-case-link';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Lands the partner's E-Verify case deep link (`/everifycase?pt=<token>`) on the real case screen
 * at `/e-verify/case/:everifyCaseQueueId`.
 *
 * The employer's other partner-minted link, `/sectiontwo?pt=`, is resolved the same way by
 * `PartnerSection2Redirect` — this is that pattern, not a second one. Without a `/everifycase`
 * route the router's catch-all would send the link to `/unauthorized`: a "403 Access Denied" that
 * logging in could never fix, because it was never an authorization failure.
 *
 * Deliberately a **redirect, not a second E-Verify screen**: the destination keeps its own
 * `eVerify.read` guard, so this changes how the employer arrives, never what they may do. The token
 * names the case; the session authorizes it.
 *
 * An unreadable token, one minted for another capability, or one carrying no queue id falls through
 * to `/unauthorized`.
 */
export default function PartnerEverifyCaseRedirect() {
  const [searchParams] = useSearchParams();
  const everifyCaseQueueId = everifyCaseQueueIdFromPartnerToken(searchParams.get('pt'));

  if (!everifyCaseQueueId) return <Navigate to="/unauthorized" replace />;

  // `replace`, so the bearer token is not left in history behind a Back press.
  return <Navigate to={`/e-verify/case/${everifyCaseQueueId}`} replace />;
}
